<template>
  <div class="editable-content-field">
    <span
      v-if="!editable"
      class="editable-content-field__value"
      @input="updateValue"
      :title="value"
    >
      {{ value }}
    </span>
    <textarea
      v-if="editable"
      v-model.trim="value"
      class="editable-content-field__textarea"
      :rows="1"
      :columns="1"
    />
    <i
      class="editable-content-field__icon mdi"
      :class="{
        'mdi-check-bold': editable,
        'mdi-circle-edit-outline': !editable,
      }"
      @click="editable ? applyChanges() : makeEditable()"
    />
  </div>
</template>

<script>
const EVENTS = {
  updateEditable: 'update:editable',
  updateDetailsValue: 'update:details-value',
  onSave: 'on-save',
}

export default {
  name: 'editable-content-field',
  props: {
    detailsValue: { type: [String, Number], required: true },
    editable: { type: Boolean, default: true },
  },
  data () {
    return {
      value: this.detailsValue || '-',
    }
  },
  methods: {
    makeEditable () {
      this.$emit(EVENTS.updateEditable, true)
    },
    makeNonEditable () {
      this.$emit(EVENTS.updateEditable, false)
    },
    updateValue (e) {
      this.value = e.target.innerText
    },
    applyChanges () {
      this.value = this.removeLineBreaks(this.value)
      this.makeNonEditable()
      this.$emit(EVENTS.updateDetailsValue, this.value)
      if (this.value !== this.detailsValue) {
        this.$emit(EVENTS.onSave)
      }
    },
    removeLineBreaks (value) {
      return value.replace(/(\s{2,})/gm, ' ')
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'scss/variables';

.editable-content-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  user-select: auto;
}

.editable-content-field__value {
  padding: 0.3rem;
  border: 0.1rem solid transparent;
}

.editable-content-field__icon {
  margin-left: 1rem;
  font-size: 1.9rem;
  color: $col-editable-content-outline;
  cursor: pointer;
}

.editable-content-field__textarea {
  -webkit-text-fill-color: $field-color-text;
  caret-color: $field-color-focused;
  min-height: 2.6rem;
  height: 2.6rem;
  background: none;
  resize: vertical;
  overflow: hidden;

  text-align: right;
  border: 0.1rem solid;
  border-radius: 0.3rem;
  padding: 0.3rem;
  padding-top: 0.4rem;
}
</style>
